import {IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IApiEndpoint} from "@localization/siteMap/siteMapInterfaces.ts";

export const __arquivos_endpoints = {
    v2: {
        ['get-by-id']: (data: IDataNoPageDto<{ idArquivo: number }>): IApiEndpoint<Blob> => {
            const {idArquivo} = data.data

            return {
                url: `/api/v2/arquivos/${idArquivo}`,
                method: 'GET',
                data: {...data, data: {}}
            }
        },
        ['get-by-guid']: (data: IDataNoPageDto<{ guid: string }>): IApiEndpoint<Blob> => {
            const {guid} = data.data

            return {
                url: `/api/v2/arquivos/getbyguid/${guid}`,
                method: 'GET',
                data: {...data, data: {}}
            }
        }
    }
}